module.exports = __webpack_public_path__ + "img/Drop Down Button.34bc0e96.svg";